import type { FaireThemeEntity } from "../../entity_types/theme";

export const recycled_glass_tiki_bar: FaireThemeEntity = {
  token: "recycled-glass-tiki-bar",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Recycled-Glass Tiki Bar",
  description: "Eco-friendly barware for your island aesthetic",
  bgColor: "#F0D4C4",
  tileBgColor: "#337e47",
  productTokens: [
    "p_mwgx83zgkh",
    "p_g548sdahe5",
    "p_hmma76xjhy",
    "p_jvkff446cp",
    "p_mkd8y8cb7j",
    "p_2abc3hengk",
    "p_mmacpu3tmw",
    "p_mpbbq4j9nd",
    "p_dq5w4b1q2o",
    "p_1beqghnpbf",
    "p_zs2kxjsr2c",
    "p_bexjxt92v3",
    "p_3hpjgknyfk",
    "p_mquej8ekdg",
    "p_ju62emas2y",
    "p_9bjzspf5hp",
    "p_vm2ypeff3z",
    "p_jpc5bmrrdc",
    "p_gnd99g4vw4",
    "p_r5y6c9f9c5",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
